<template>
  <b-container> 
      <b-card>
        <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
        <b-row>
            <b-col>
                <div class="row mb-md-2">
                    <div class="col-sm-12 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Mostrar
                                <b-form-select
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select
                                > deportes
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Buscar:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    placeholder="Escribe un deporte"
                                    class="form-control form-control-sm ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <b-table
                :items="sports"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                show-empty
                empty-text="Sin datos para mostrar"
                hover
                @row-clicked="rowClicked"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                head-variant="light">
                </b-table>
                <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
      </b-card>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'
import Counter from '@/components/core/counter/Counter'
import config from '@/config/constant';

export default {
  name: 'Deportistas',
  components: {
    Counter
  },
  metaInfo: {
      title: "AT Pro - Deportistas Hombres"
  },
  data () {
    return {
      loading: true,
      loading1: true,
      countSportsKey: 1,
      countSports: 0,
      perPage: 10,
      currentPage: 1,
      sports: [],
      sport_categories: [],
      filter: null,
      filterOn: [],
      pageOptions: [10, 25, 50, 100],
      fields: [
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'count', label: 'Cantidad', sortable: true }
      ]
    }
  },
  computed: {
    rows () {
      return this.sports.length || 0
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getAthletes (sex) {
        const gender = sex.charAt(0).toUpperCase() + sex.slice(1).toLowerCase()
        axios.get(`${config.apiUrl}/countSportsMembers/${gender}`)
        .then(r => {
          console.log('✅ Athletes Sports List!', r.data.data)
          this.sports = r.data.data.map(e => {
            return e
          })
          this.loading = false;
          this.loading1 = false;
        })
        .catch(e => {
          console.error('Error Sports', e)
        })
    },
    rowClicked (row) {
        this.$router.push({ name: 'atpro.sport-profile', params: { id: row.sport_id, gender: this.$route.params.gender } })
    }
  },
  created () {
    this.getAthletes(this.$route.params.gender)
  },
  mounted () {
    core.index()
  }
}
</script>
